import ApiService from "../common/apiService";
import { GET_FORUM_CATEGORIES, LOAD_FORUM_CATEGORIES, GET_FORUM_THREADS, LOAD_FORUM_THREADS,
  GET_THREAD_DETAILS, CREATE_FORUM_THREAD, EDIT_FORUM_THREAD, DELETE_FORUM_THREAD, CREATE_FORUM_REPLY,
  GET_FORUM_DOCUMENT, EDIT_FORUM_REPLY, DELETE_FORUM_REPLY, GET_FOLLOWING_STATUS, FOLLOW_UNFOLLOW, FORUM_SEARCH } from "./actions.type";
import { forceDownload, filePreview } from "@/common/documentFunctions"

const ForumsModule = {
  state: {
    categories: [],
    forums: [],
    selectedThread: {}
  },
  getters: {
  },
  mutations: {

  },
  actions: {
    [GET_FORUM_DOCUMENT](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.request({
          'method': 'get',
          'url': "/forumdocument/" + payload.id,
          responseType: 'blob'
        }).then(response => {
          forceDownload(response);
          resolve(true);
        })
          .catch(error => {
            reject(error.response.data.message);
          });
      });
    },
    [CREATE_FORUM_REPLY](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.post("/forumreply", payload)
          .then((response) => {
            resolve(response.data);
          }).catch(error => {
            reject(error.response.data.message);
          });
      });
    },
    [EDIT_FORUM_REPLY](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.post("/forumreply/"+payload.id, payload.formData)
          .then((response) => {
            resolve(response.data);
          }).catch(error => {
            reject(error.response.data.message);
          });
      });
    },
    [DELETE_FORUM_REPLY](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.delete("/forumreply/"+payload.id)
          .then((response) => {
            resolve(response.data);
          }).catch(error => {
            reject(error.response.data.message);
          });
      });
    },
    [CREATE_FORUM_THREAD](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.post("/forumthreads", payload)
          .then((response) => {
            resolve(response.data);
          }).catch(error => {
            reject(error.response.data.message);
          });
      });
    },
    [EDIT_FORUM_THREAD](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.post("/forumthreads/"+payload.id, payload.formData)
        .then((response) => {
            resolve(response.data);
          }).catch(error => {
            reject(error.response.data.message);
          });
      });
    },
    [DELETE_FORUM_THREAD](context, payload) {
      return new Promise((resolve, reject) => {
        ApiService.delete("/forumthreads/"+payload.id)
          .then((response) => {
            resolve(response.data);
          }).catch(error => {
            reject(error.response.data.message);
          });
      });
    },
    [GET_FORUM_CATEGORIES](context, payload) {
      if (context.state.categories.length > 0) {
        return context.state.categories;
      }
      return context.dispatch(LOAD_FORUM_CATEGORIES, {});
    },
    async [LOAD_FORUM_CATEGORIES](context, payload) {
      let res = {};
      let url = "/forumcategories";
      await ApiService.get(url)
        .then(response => {
          let items = response.data.data;
          res = items;
        })
        .catch(error => {
          res = error;
        });
      context.state.categories = res;
      return context.state.categories;
    },
    [GET_FORUM_THREADS](context, payload) {
      if (context.state.forums.length > 0 && payload.useCacheIfExists) {
        return context.state.forums;
      }
      return context.dispatch(LOAD_FORUM_THREADS, payload);
    },
    async [LOAD_FORUM_THREADS](context, payload) {
      let res = {};
      let url = "/forumthreads?committeeid=" + payload.committeeid;
      await ApiService.get(url)
        .then(response => {
          let items = response.data.data;
          res = items;
        })
        .catch(error => {
          res = error;
        });
      context.state.forums = res;
      return context.state.forums;
    },
    async [GET_THREAD_DETAILS](context, payload) {
      let res = {};
      let url = "/forumthreads/" + payload.id;
      await ApiService.get(url)
        .then(response => {
          let item = response.data.data;
          context.state.selectedThread = item;
          res = item;
        })
        .catch(error => {
          res = error;
        });
      return res;
    },
    [GET_FOLLOWING_STATUS](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.get("/forum/isfollowing/"+payload.id)
      .then(response => {
        resolve(response.data.data);
      })
        .catch(error => {
          reject(error.response.data.message);
        });
    });
  },
  [FOLLOW_UNFOLLOW](context, payload) {
    return new Promise((resolve, reject) => {
      let url = payload.isFollowing ? 'unfollow' : 'follow';
      ApiService.get("/forum/"+url+"/"+payload.id)
      .then(response => {
        resolve(response.data.data);
      })
        .catch(error => {
          reject(error.response.data.message);
        });
    });
  },
  [FORUM_SEARCH](context, payload) {
    return new Promise((resolve, reject) => {
      let url = "/forum/search?term="
      ApiService.get(url+payload.term+"&cmid="+payload.cmid)
      .then(response => {
        resolve(response.data.data);
      })
        .catch(error => {
          reject(error.response.data.message);
        });
    });
  },


  },

}

export default ForumsModule;
